import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./common/Navbar";
import Home from "./Components/Home";
import About from "./Components/About";
import AviationDomain from "./Components/Domains/AviationDomain";
import HealthcareDomain from "./Components/Domains/HealthcareDomain";
import LogisticsDomain from "./Components/Domains/LogisticsDomain";
import ConstructionDomain from "./Components/Domains/ConstructionDomain";
import RetailDomain from "./Components/Domains/RetailDomain";
import LMS from "./Components/Products/LMS";
import Examiner from "./Components/Products/Examiner";
import CCD from "./Components/Products/CCD";
import Blogs from "./Components/Blogs";
import Blog from "./Components/Blog";
import Footer from "./common/Footer";
import RequestDemo from "./Components/RequestDemo";

const App = () => {
  return (
    <>
      <div className="main">
        <div className="watermark"></div>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/aviation" element={<AviationDomain />} />
          <Route path="/healthcare" element={<HealthcareDomain />} />
          <Route path="/logistics" element={<LogisticsDomain />} />
          <Route path="/construction" element={<ConstructionDomain />} />
          <Route path="/retail" element={<RetailDomain />} />
          <Route path="/lms" element={<LMS />} />
          <Route path="/examiner" element={<Examiner />} />
          <Route path="/customcoursedevelopment" element={<CCD />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/request" element={<RequestDemo />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
};

export default App;
